import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'

const app = createApp(App)
app.use(router)

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'production',
    release: `infinela-plugin@${import.meta.env.VITE_APP_VERSION ?? '0.1.0'}`,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: 0,
    beforeSend(event) {
      const status = event.extra?.status as number | undefined
      if (status && [400, 401, 403, 404, 422].includes(status)) {
        return null
      }
      return event
    },
  })
}

app.mount('#app')
